<div *ngIf="format == 'html'">
    <ng-container *ngIf="!(isHtmlDocumentLoading$ | async); else htmlLoadingSpinner">
        <div [innerHtml]="htmlContent" class="viewport-doc document-typo"></div>
    </ng-container>

    <ng-template #htmlLoadingSpinner>
        <div class="spinner-block">
            <mat-progress-spinner
                [color]="'accent'"
                [diameter]="50"
                [mode]="'indeterminate'">
            </mat-progress-spinner>
        </div>
    </ng-template>
</div>
<div *ngIf="format == 'pdf' && saveUrl">
    <object [data]="saveUrl" type="text/html" class="viewport-doc">
        <embed [src]="saveUrl" type="application/pdf" width="100%" height="100%">
            <a [href]="saveUrl" target="_blank">Document.pdf</a>
    </object>
</div>
